import { IAppState } from 'shared/common/state';
import { isArrayWithItems } from 'shared/utils';

import { selectOffersCount } from '../results';

export function selectIsQuickLinksAvailable(state: IAppState): boolean {
  const { quickLinks, oldQuickLinks, avgPriceInformer } = state.results;

  // На пустой выдаче блок не показываем: ссылки приходят по ЧПУ и не зависят от фильтров,
  // поэтому без этой проверки они отображаются вместе с заглушкой «У нас ещё нет таких объявлений»
  if (selectOffersCount(state) === 0) {
    return false;
  }

  const hasTabs = isArrayWithItems(quickLinks) && quickLinks.some(tab => isArrayWithItems(tab.links));
  const hasOldQuickLinks = Boolean(oldQuickLinks && isArrayWithItems(oldQuickLinks.links));

  return hasTabs || hasOldQuickLinks || Boolean(avgPriceInformer);
}
